import { __assign } from "tslib";
import React, { Suspense } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { useIsMounted } from '../utils/hooks/useIsMounted';
export default function withLoadableComponent(LoadableComponent, fallback) {
    if (fallback === void 0) { fallback = null; }
    var NewLoadable = function (props) {
        var isMounted = useIsMounted();
        return !isMounted ? null : (React.createElement(ErrorBoundary, { debugComponent: "withLoadableComponent" },
            React.createElement(Suspense, { fallback: fallback },
                React.createElement(LoadableComponent, __assign({}, props)))));
    };
    NewLoadable.displayName = "Loadable(" + LoadableComponent.displayName + ")";
    return NewLoadable;
}
//# sourceMappingURL=withLoadableComponent.js.map